module.exports = __webpack_public_path__ + "assets/img/litstwo.bffbde56.png";